/**
 * localStorage mirror of the signed-in session — UI/cache only.
 * Source of truth: Firebase Auth + Firestore users/{email}.
 */

export const AUTH_LOCAL_KEYS = [
  "isAuthenticated",
  "currentUserId",
  "userEmail",
  "userPermissions",
  "userEmployeeId",
  "twoFaVerifiedAt",
  "twoFaVerifiedEmail",
];

/**
 * Writes the mirror after permissions are confirmed from Firestore (or login flow).
 */
export function syncAuthLocalMirror(userData) {
  if (!userData) return;
  localStorage.setItem("isAuthenticated", "true");
  localStorage.setItem("currentUserId", userData.id || "");
  localStorage.setItem("userEmail", userData.email || "");
  localStorage.setItem(
    "userPermissions",
    userData.permissions || "childUser",
  );
  localStorage.setItem("userEmployeeId", userData.employeeId || "");
}

/** Clears session mirror + 2FA stamp (does not clear unrelated keys like Tsav cache). */
export function clearAuthLocalMirror() {
  for (const k of AUTH_LOCAL_KEYS) {
    localStorage.removeItem(k);
  }
}
